import './index.css'
import { BrowserRouter as Router ,Routes,Route } from 'react-router-dom';
import Home from './pages/Home';
import Login from './pages/Login';



function App() {
  return (
    <>
   <Router>
    <Routes>
    <Route path='/' element={<Home/>}></Route>
    <Route path='/login' element={<Login/>} />
    </Routes>
   </Router>
    </>
  );
}

export default App;
